// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n6cbJ","img":"styles_img__8eYTI","container":"styles_container___Ie_y","title":"styles_title__KIGGw","subtitle":"styles_subtitle__GxFCd"};